import { Component, Input } from '@angular/core';

type Sizes = 'small' | 'medium' | 'large';

@Component({
  selector: 't-branding',
  imports: [],
  templateUrl: './branding.component.html',
})
export class BrandingComponent {
  @Input({ required: true }) logoUrl = '';
  @Input() size: Sizes = 'medium';
}
